import { Link } from 'react-router'
import React, { useContext } from 'react'
import { observer } from 'mobx-react'

// evertel
import { Col, Icon, Text } from '@evertel/web/ui'
import { RoomContext } from '../../RoomContext'
import { RoomRepliesSearchSelect } from '../RoomRepliesSearchSelect'


const RoomReplies: React.FC = observer(() => {

    const { roomController: { room }, toggleAside } = useContext(RoomContext)

    return (
        <Col className="room-replies-aside">
            <Link
                to={`/room/${room.id}`}
                onClick={() => toggleAside('replies', 'close')}
                className="btn btn-primary reply-button text-center p-3 mx-3 mb-0"
            >
                <Icon
                    name="envelope"
                    type="solid"
                    className="icon"
                />
                <Text className="text ms-2" >
                    All messages in  #<i><strong>{room.name}</strong></i>
                </Text>
            </Link>
            <Col className="mt-3 w-100">
                <RoomRepliesSearchSelect
                    onSelect={() => toggleAside('replies', 'close')}
                    menuIsOpen
                    maxMenuHeight="calc(100vh - 220px)"
                    className="no-bg search space-below"
                />
            </Col>
        </Col>
    )
})

export { RoomReplies }
